import React from 'react';
import {archetypeLabel} from '../../../support/strategyLabels';
import {CheckCheckIcon} from '../../icons';
import {FALLBACK_STEPS, STEP_CODES} from '../constants';
import {StepProps, asRecord, listField, stringField} from './types';

/** Номер слота шага по его коду — итоги берём из ответов по тем же ключам, что и мастер. */
const slotOf = (code: string): string =>
    String(FALLBACK_STEPS.find(s => s.code === code)?.number ?? 0);

/**
 * Финальный шаг (слот 14): что мастер собрал и что будет дальше. Кнопка «Готово» живёт в
 * оболочке мастера — она вызывает `POST /api/onboarding/complete`.
 */
const StepDone: React.FC<StepProps> = ({answers}) => {
    const strategy = answers[slotOf(STEP_CODES.strategy)];
    const style = answers[slotOf(STEP_CODES.style)];
    const location = answers[slotOf(STEP_CODES.location)];
    const firstItem = asRecord(answers[slotOf(STEP_CODES.firstItem)]);

    const archetype = stringField(strategy, 'archetype');
    const styleNames = listField(style, 'styleNames');
    const city = stringField(location, 'city');
    const photoCount = Number(firstItem.photoCount ?? 0);

    const summary: {label: string; value: string}[] = [
        {label: 'Стратегия', value: archetype ? archetypeLabel(archetype) : 'не выбрана — можно задать на странице «Стратегия»'},
        {label: 'Стили', value: styleNames.length > 0 ? styleNames.join(', ') : 'не выбраны'},
        {label: 'Город', value: city || 'не указан'},
        {label: 'Отправлено фото', value: photoCount > 0 ? String(photoCount) : 'нет'},
    ];

    return (
        <div className="space-y-4" data-testid="onboarding-step-done">
            <div className="flex items-start gap-3">
                <CheckCheckIcon className="w-6 h-6 text-emerald-600 dark:text-emerald-400 shrink-0"/>
                <p className="text-sm text-gray-600 dark:text-gray-300">
                    Нажмите «Готово» — настройки применятся к стратегии и профилю, и стилист начнёт
                    работать с вашими данными.
                </p>
            </div>
            <dl className="divide-y divide-gray-100 dark:divide-white/5" data-testid="onboarding-summary">
                {summary.map(row => (
                    <div key={row.label} className="flex items-baseline justify-between gap-4 py-2">
                        <dt className="text-sm text-gray-500 dark:text-gray-400">{row.label}</dt>
                        <dd className="text-sm text-gray-900 dark:text-gray-100 text-right">{row.value}</dd>
                    </div>
                ))}
            </dl>
        </div>
    );
};

export default StepDone;
